/* ============================================================
   JGNT Hero Banner - comportamiento  ·  v6.1

   Tres trabajos:

     1. Videos de fondo: arrancarlos, pausa y sonido.
     2. v2: el carrusel cuando hay varios banners. Flechas en
        escritorio y saber cual banner esta a la vista.
     3. v3: indicador (cuadritos) y cambio automatico.
        v5: barra de tiempo. v6: cambio con wipe (ver abajo).

   ------------------------------------------------------------
   v6 (oct 10 2026) - CAMBIO CON WIPE DESVANECIDO

   Los banners ya no se deslizan uno junto al otro: estan
   apilados en la misma celda (grid, ver el CSS) y el que entra
   aparece ENCIMA del activo con una mascara (mask-image) que
   barre de lado con el borde difuminado, como los wipes de Star
   Wars pero con orilla suave. Avanzar entra desde la derecha,
   regresar desde la izquierda.

     - flechas, cuadritos, trackpad y cambio automatico corren
       el wipe completo (ajuste "Duracion del wipe"),
     - el dedo lo maneja a mano: el wipe sigue al dedo y al
       soltar se completa o se cierra,
     - el ancho del difuminado es el ajuste "Suavidad del borde"
       (0 = corte limpio),
     - con movimiento reducido no hay wipe: el cambio es directo.

   La mascara se pinta desde JS cuadro a cuadro (no con una
   transicion de CSS) porque el mismo pintado sirve para la
   animacion y para seguir el dedo. Cuenta por reloj, asi dura lo
   mismo aunque el telefono baje los cuadros.

   Como no hay posiciones, el carrusel no tiene fin sin trucos:
   despues del ultimo sigue el primero y ya. Por eso desaparecen
   las copias y el reacomodo con `order` de v5 a v5.2.

   Historia: hasta v5.1 era scroll nativo con scroll-snap, que en
   iPhone se desfasaba con el reacomodo y dejaba ver el fondo
   negro; v5.2 lo cambio a transform. v6 quita el deslizamiento.

   Los banners fuera de vista llevan inert, para que el tabulador
   no entre a botones que no se ven.

   ------------------------------------------------------------
   UN SOLO VIDEO ACTIVO A LA VEZ

   Cada banner puede traer DOS videos: el de escritorio y uno
   propio para movil. Y puede haber hasta diez banners. Solo UNO
   de todos esos videos corre: el del banner a la vista, en el
   ancho actual. Importa por dos razones:

     1. Ancho de banda. Los <source> llegan con data-src y sin
        src, asi que nada se descarga hasta que el script lo
        pide. Un video se pide la primera vez que su banner queda
        a la vista, en el ancho que toca. Un telefono nunca baja
        el video de escritorio, ni los de banners que no visito.

     2. Audio. Un <video> fuera de vista SIGUE SONANDO si esta
        reproduciendo sin mute. Por eso todo video inactivo se
        pausa y se silencia.

   Cada banner guarda su propio estado de pausa y sonido. Si
   quitas el silencio en uno y pasas al siguiente, el anterior se
   calla; al volver, recupera su estado.

   ------------------------------------------------------------
   v3 - CAMBIO AUTOMATICO

   Lo prende data-hb-autoplay="N" en la raiz (N = segundos), que
   la seccion solo imprime con dos banners o mas.

     - Banner con FOTO: avanza a los N segundos.
     - Banner con VIDEO: no cuenta segundos, espera el evento
       'ended'. Para que 'ended' exista, a los videos se les quita
       el loop mientras el cambio automatico este prendido. Con un
       solo banner no hay cambio automatico y el loop se queda.
     - Si el visitante PAUSA el video con su boton, el carrusel se
       queda ahi hasta que lo reanude.
     - Si el NAVEGADOR bloquea el video (ahorro de bateria en
       iPhone), se usa el temporizador normal para no quedarse
       atorado en un banner que nunca va a terminar.
     - Del ultimo banner sigue al primero.
     - Tocar flecha, cuadrito o deslizar reinicia la cuenta.
     - Se detiene con el cursor encima (escritorio), mientras el
       dedo esta sobre el banner, con la pestana oculta, con
       movimiento reducido y dentro del editor de Shopify (que no
       se mueva mientras editas). Si un video termina con el
       cursor encima, vuelve a empezar en vez de avanzar.

   ------------------------------------------------------------
   v5.1 - FOTOS DE LOS VECINOS

   Las fotos de los demas banners llegan con loading=lazy, y
   Safari no carga una foto lazy oculta hasta que ya esta a la
   vista: entraria un cuadro negro. Al terminar de cargar la
   pagina se les cambia a eager.

   ------------------------------------------------------------
   v5 - BARRA DE TIEMPO

   A la izquierda de los cuadritos. Se llena en los segundos del
   ajuste y al llenarse cambia de banner; en un banner con video
   sigue el avance del video. Con el cursor encima, el dedo sobre
   el banner o la pestana oculta se congela, y despues SIGUE
   donde iba (antes la cuenta volvia a empezar). Con movimiento
   reducido no hay cambio automatico y la barra se esconde. En el
   editor se ve vacia, porque ahi no hay cambio automatico.

   ------------------------------------------------------------
   AUTOPLAY DEL VIDEO

   Arranca en silencio porque los navegadores solo dejan
   reproducir solo un video mudo. Por eso el <video> lleva muted y
   playsinline en el HTML: iOS los exige desde el marcado.

   Si el navegador bloquea la reproduccion (NotAllowedError), el
   boton pasa a mostrar "play". Cualquier otro rechazo, como el
   AbortError que sale al cambiar de video a media carga, se
   ignora.

   ------------------------------------------------------------
   EN EL EDITOR

   La seccion se vuelve a renderizar entera al mover un ajuste, y
   llega como shopify:section:load. Cada raiz se marca al
   iniciarse para no amarrarle dos veces los mismos listeners.
   Al seleccionar un bloque Banner en la barra lateral, el
   carrusel salta a ese banner.
   ============================================================ */

(function () {
  if (window.jgntHeroBannerReady) return;
  window.jgntHeroBannerReady = true;

  var DESKTOP = window.matchMedia('(min-width: 750px)');
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function onChange(query, handler) {
    if (query.addEventListener) query.addEventListener('change', handler);
    else if (query.addListener) query.addListener(handler);
  }

  function now() {
    return window.performance && window.performance.now ? window.performance.now() : Date.now();
  }

  /* ---------- Un banner: sus videos y sus controles ---------- */

  function initSlide(slide, labels, hooks) {
    var desktopVideo = slide.querySelector('[data-hb-video="desktop"]');
    var mobileVideo = slide.querySelector('[data-hb-video="mobile"]');
    var ownMobile = slide.hasAttribute('data-hb-mobile-own');
    var playButton = slide.querySelector('[data-hb-play]');
    var soundButton = slide.querySelector('[data-hb-sound]');

    /* paused: el visitante (o movimiento reducido) lo pauso.
       blocked: el navegador no dejo reproducir. Son distintos para
       el cambio automatico: el primero espera, el segundo no. */
    var state = { paused: REDUCED.matches, muted: true, active: false, blocked: false, visible: !('IntersectionObserver' in window) };

    /* Cual video manda en el ancho actual. Puede ser null: por
       ejemplo, escritorio con video y movil con foto propia. */
    function current() {
      if (DESKTOP.matches) return desktopVideo;
      return ownMobile ? mobileVideo : desktopVideo;
    }

    function load(video) {
      if (video.jgntHbLoaded) return;
      video.jgntHbLoaded = true;

      var sources = video.querySelectorAll('source[data-src]');
      for (var i = 0; i < sources.length; i++) {
        sources[i].setAttribute('src', sources[i].getAttribute('data-src'));
      }
      video.load();
    }

    function paint() {
      if (playButton) {
        playButton.setAttribute('data-state', state.paused ? 'paused' : 'playing');
        playButton.setAttribute('aria-label', state.paused ? labels.play : labels.pause);
      }
      if (soundButton) {
        soundButton.setAttribute('data-state', state.muted ? 'muted' : 'unmuted');
        soundButton.setAttribute('aria-label', state.muted ? labels.unmute : labels.mute);
      }
    }

    function sync() {
      var active = state.active ? current() : null;

      /* Fuera de pantalla no se carga ni se reproduce: un video en
         loop bajo el scroll seguia bajando segmentos HLS. */
      if (active && !state.visible) {
        active.pause();
        active = null;
      }

      [desktopVideo, mobileVideo].forEach(function (video) {
        if (!video || video === active) return;
        video.muted = true;
        video.pause();
      });

      if (active) {
        load(active);
        active.muted = state.muted;

        if (state.paused) {
          active.pause();
        } else {
          var attempt = active.play();
          if (attempt && typeof attempt.catch === 'function') {
            attempt.catch(function (error) {
              if (error && error.name === 'NotAllowedError') {
                state.paused = true;
                state.blocked = true;
                paint();
                hooks.changed();
              }
            });
          }
        }
      }

      paint();
    }

    if (playButton) {
      playButton.addEventListener('click', function () {
        state.paused = !state.paused;
        state.blocked = false;
        sync();
        hooks.changed();
      });
    }

    if (soundButton) {
      soundButton.addEventListener('click', function () {
        state.muted = !state.muted;
        sync();
      });
    }

    [desktopVideo, mobileVideo].forEach(function (video) {
      if (!video) return;
      video.addEventListener('ended', function () {
        if (state.active && video === current()) hooks.ended(video);
      });
    });

    return {
      sync: sync,
      videos: [desktopVideo, mobileVideo].filter(Boolean),
      /* v5: el video que manda ahora, para que la barra lo siga. */
      video: current,
      setActive: function (value) {
        if (state.active === value) return;
        state.active = value;
        sync();
      },
      setVisible: function (value) {
        if (state.visible === value) return;
        state.visible = value;
        sync();
      },
      /* Que hace el cambio automatico con este banner:
         'timer' cuenta segundos, 'video' espera a que termine,
         'hold' se queda (el visitante pauso el video). */
      autoMode: function () {
        if (!current()) return 'timer';
        if (state.blocked) return 'timer';
        if (state.paused) return 'hold';
        return 'video';
      },
    };
  }

  /* ---------- La seccion: el carrusel ---------- */

  function init(root) {
    if (!root || root.jgntHbReady) return;
    root.jgntHbReady = true;

    var track = root.querySelector('[data-hb-track]');
    if (!track) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-hb-slide]'));
    if (!slides.length) return;

    var labels = {
      play: root.getAttribute('data-l-play') || 'Play',
      pause: root.getAttribute('data-l-pause') || 'Pause',
      unmute: root.getAttribute('data-l-unmute') || 'Unmute',
      mute: root.getAttribute('data-l-mute') || 'Mute',
    };

    var prev = root.querySelector('[data-hb-prev]');
    var next = root.querySelector('[data-hb-next]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hb-dot]'));
    var bar = root.querySelector('[data-hb-bar]');
    var barFill = bar ? bar.querySelector('[data-hb-bar-fill]') : null;
    var multi = slides.length > 1;
    var index = -1;

    /* ----- Cambio automatico: estado ----- */
    var seconds = parseInt(root.getAttribute('data-hb-autoplay'), 10);
    var inEditor = !!(window.Shopify && window.Shopify.designMode);
    var autoplay = multi && seconds > 0 && !REDUCED.matches && !inEditor;
    var delay = (seconds || 6) * 1000;
    var timer = null;
    var hovering = false;
    var touching = false;

    /* v5: lo ya contado en el banner actual. Con esto una pausa
       congela la barra y al soltar sigue donde iba. */
    var elapsed = 0;
    var startedAt = 0;
    var running = false;
    var raf = null;

    if (bar && REDUCED.matches) bar.hidden = true;

    var controllers = slides.map(function (slide) {
      return initSlide(slide, labels, {
        changed: function () {
          schedule();
        },
        ended: function (video) {
          if (!autoplay) return;
          if (hovering || touching) {
            video.currentTime = 0;
            var again = video.play();
            if (again && typeof again.catch === 'function') again.catch(function () {});
            return;
          }
          advance();
        },
      });
    });

    /* Sin loop, 'ended' puede dispararse. Solo con cambio
       automatico: si no, el video se repite como siempre. */
    if (autoplay) {
      controllers.forEach(function (controller) {
        controller.videos.forEach(function (video) {
          video.loop = false;
        });
      });
    }

    function stop() {
      window.clearTimeout(timer);
      timer = null;
      if (running) {
        elapsed += now() - startedAt;
        running = false;
      }
    }

    function reset() {
      stop();
      elapsed = 0;
    }

    function advance() {
      go(index + 1, true, 1);
    }

    /* v5: cuanto lleva el banner actual, de 0 a 1. */
    function progress() {
      if (index < 0) return 0;
      var controller = controllers[index];
      if (controller.autoMode() !== 'timer') {
        var video = controller.video();
        if (video && video.duration && isFinite(video.duration)) {
          return Math.min(1, video.currentTime / video.duration);
        }
        return 0;
      }
      var spent = elapsed + (running ? now() - startedAt : 0);
      return Math.min(1, spent / delay);
    }

    /* v5: pinta la barra y, mientras algo avanza, se vuelve a
       pedir en el siguiente cuadro. */
    function paintBar() {
      if (raf !== null) {
        window.cancelAnimationFrame(raf);
        raf = null;
      }
      if (!barFill) return;
      barFill.style.transform = 'scaleX(' + progress().toFixed(4) + ')';
      var live = autoplay && index >= 0 && !document.hidden && (running || controllers[index].autoMode() === 'video');
      if (live) raf = window.requestAnimationFrame(paintBar);
    }

    /* Decide que esperar en el banner actual. Se llama cada vez que
       algo cambia: nuevo banner, pausa, cursor, pestana. */
    function schedule() {
      stop();
      if (autoplay && index >= 0 && !hovering && !touching && !document.hidden) {
        var mode = controllers[index].autoMode();
        if (mode === 'timer') {
          if (elapsed >= delay) elapsed = 0;
          running = true;
          startedAt = now();
          timer = window.setTimeout(advance, delay - elapsed);
        }
        /* 'video': avanza el listener de 'ended'. 'hold': nada. */
      }
      paintBar();
    }

    /* Sep 26 2026: los puntos se pintan aparte y al momento. Antes
       solo cambiaban en setIndex, que espera a que el deslizamiento
       termine (scrollend o 120ms sin scroll), y el marcador llegaba
       tarde respecto al banner. */
    var shownDot = -1;
    function paintDots(i) {
      if (i === shownDot) return;
      shownDot = i;
      dots.forEach(function (dot, k) {
        if (k === i) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    function setIndex(i) {
      if (i === index) return;
      index = i;

      /* v6: el activo queda debajo de todo lo que entre. */
      slides.forEach(function (slide, k) {
        slide.classList.toggle('is-active', k === index);
      });

      controllers.forEach(function (controller, k) {
        controller.setActive(k === index);
      });

      if (multi) {
        slides.forEach(function (slide, k) {
          if (k === index) slide.removeAttribute('inert');
          else slide.setAttribute('inert', '');
        });
      }

      paintDots(index);
      reset();
      schedule();
    }

    /* ----- El wipe (v6) -----
       `incoming` es el banner que esta entrando, `dir` su lado
       (+1: entra desde la derecha, -1: desde la izquierda) y `t`
       cuanto lleva, de 0 a 1. `anim` es la animacion en curso. */
    var wipeMs = parseInt(root.getAttribute('data-hb-wipe-ms'), 10) || 900;
    var soft = parseInt(root.getAttribute('data-hb-wipe-soft'), 10);
    soft = isNaN(soft) ? 0.3 : soft / 100;
    var incoming = null;
    var dir = 1;
    var t = 0;
    var anim = null;

    /* Pinta la mascara del banner que entra. El borde recorre de
       -soft a 1 para que al principio no se vea nada y al final no
       quede nada difuminado. "to left" mide desde la orilla
       derecha: asi el banner que avanza entra por la derecha. */
    function paintWipe() {
      if (incoming === null) return;
      var edge = -soft + t * (1 + soft);
      var side = dir > 0 ? 'to left' : 'to right';
      var mask =
        'linear-gradient(' + side + ', #000 ' + (edge * 100).toFixed(2) + '%, transparent ' + ((edge + soft) * 100).toFixed(2) + '%)';
      var el = slides[incoming];
      el.style.webkitMaskImage = mask;
      el.style.maskImage = mask;
    }

    function clearIncoming() {
      if (incoming === null) return;
      var el = slides[incoming];
      el.classList.remove('is-incoming');
      el.style.webkitMaskImage = '';
      el.style.maskImage = '';
      incoming = null;
      t = 0;
    }

    /* Pone `k` encima del activo, tapado del todo, listo para
       barrer desde el lado `d`. */
    function begin(k, d) {
      if (incoming !== k) clearIncoming();
      incoming = k;
      dir = d;
      t = 0;
      slides[k].classList.add('is-incoming');
      paintWipe();
    }

    /* El banner que entro pasa a ser el activo. */
    function commit() {
      var k = incoming;
      clearIncoming();
      if (k !== null) setIndex(k);
    }

    /* Entra y sale suave: para flechas, cuadritos y cambio
       automatico, que arrancan desde quieto. */
    function ease(x) {
      return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
    }

    /* v6.1: arranca a toda velocidad y frena. Para soltar el dedo:
       el wipe ya va en movimiento y no debe detenerse. Su velocidad
       inicial es 3 veces (distancia / duracion); release() usa eso
       para empatarla con la del dedo. */
    function easeOut(x) {
      return 1 - Math.pow(1 - x, 3);
    }

    /* Lleva `t` hasta `to` en `ms` y luego llama `done`. Cuenta por
       reloj, no por cuadros: si el telefono baja los cuadros por
       ahorro de bateria, dura lo mismo. El setTimeout es el
       respaldo para cuando no hay cuadros (pestana oculta). */
    function animate(to, ms, done, curve) {
      stopAnim();
      curve = curve || ease;
      var from = t;
      var start = now();
      var entry = { to: to, done: done, raf: null, timer: null };
      anim = entry;
      var frame = function () {
        if (anim !== entry) return;
        var x = Math.min(1, (now() - start) / ms);
        t = from + (to - from) * curve(x);
        paintWipe();
        if (x < 1) entry.raf = window.requestAnimationFrame(frame);
        else end();
      };
      var end = function () {
        if (anim !== entry) return;
        stopAnim();
        t = to;
        paintWipe();
        done();
      };
      entry.timer = window.setTimeout(end, ms + 150);
      entry.raf = window.requestAnimationFrame(frame);
    }

    function stopAnim() {
      if (!anim) return;
      window.cancelAnimationFrame(anim.raf);
      window.clearTimeout(anim.timer);
      anim = null;
    }

    /* Si llega otro gesto a media animacion, la anterior se da por
       terminada en el acto. */
    function finishNow() {
      if (!anim) return;
      var entry = anim;
      stopAnim();
      t = entry.to;
      paintWipe();
      entry.done();
    }

    /* `i` es el banner del DOM y da la vuelta: -1 es el ultimo y
       slides.length es el primero. `step` (+1 o -1) dice de que
       lado entra; sin step, se deduce del orden de los banners. */
    function go(i, smooth, step) {
      finishNow();
      var n = slides.length;
      var target = ((i % n) + n) % n;

      reset();

      if (target === index) {
        clearIncoming();
        schedule();
        return;
      }

      paintDots(target);

      if (!smooth || REDUCED.matches) {
        clearIncoming();
        setIndex(target);
        return;
      }

      begin(target, step || (target > index ? 1 : -1));
      paintBar();
      animate(1, wipeMs, commit);
    }

    if (prev) {
      prev.addEventListener('click', function () {
        go(index - 1, true, -1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        go(index + 1, true, 1);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        go(parseInt(dot.getAttribute('data-hb-dot'), 10) || 0, true);
      });
    });

    if (multi) {
      /* ----- El dedo (v6) -----
         touch-action: pan-y (CSS) deja el scroll vertical de la
         pagina al navegador y nos da a nosotros el horizontal. Los
         primeros 8px deciden el eje: si el gesto es vertical, el
         banner no se mueve.

         El dedo maneja el wipe: arrastrar a la izquierda abre el
         siguiente desde la derecha, a la derecha abre el anterior
         desde la izquierda, y si cambias de lado a media
         deslizada, cambia el banner que entra.

         v6.1 - AL SOLTAR NO SE DETIENE. Antes el final usaba la
         curva de entrada y salida suave, que arranca desde
         velocidad cero: el wipe se quedaba quieto un instante donde
         lo dejaba el dedo y luego terminaba. Ahora sigue a la
         velocidad que traia el dedo y frena hasta el final
         (easeOut). Se completa si paso del 20% o si el dedo iba
         rapido abriendo; se cierra si no llego al 20% o si al
         soltar el dedo iba de regreso. */
      var startX = 0;
      var startY = 0;
      var dx = 0;
      var axis = null;
      var paintRaf = null;
      /* Ultimas posiciones del dedo, para medir su velocidad al
         soltar: [x, tiempo]. */
      var samples = [];

      /* El dedo manda mas eventos que cuadros tiene la pantalla;
         se pinta una vez por cuadro. */
      var requestPaint = function () {
        if (paintRaf !== null) return;
        paintRaf = window.requestAnimationFrame(function () {
          paintRaf = null;
          paintWipe();
        });
      };

      /* Velocidad del dedo en px/ms (+ hacia la derecha), con los
         movimientos de los ultimos 100ms. */
      var fingerSpeed = function () {
        var last = samples[samples.length - 1];
        if (!last) return 0;
        for (var i = samples.length - 2; i >= 0; i--) {
          var dt = last[1] - samples[i][1];
          if (dt >= 100 || i === 0) return dt > 0 ? (last[0] - samples[i][0]) / dt : 0;
        }
        return 0;
      };

      track.addEventListener(
        'touchstart',
        function (event) {
          if (event.touches.length > 1) return;
          finishNow();
          touching = true;
          stop();
          paintBar();
          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
          dx = 0;
          axis = null;
          samples = [[startX, now()]];
        },
        { passive: true }
      );

      track.addEventListener(
        'touchmove',
        function (event) {
          if (!touching || event.touches.length > 1) return;
          var mx = event.touches[0].clientX - startX;
          var my = event.touches[0].clientY - startY;
          if (axis === null) {
            if (Math.abs(mx) < 8 && Math.abs(my) < 8) return;
            axis = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
          }
          if (axis !== 'x') return;
          if (event.cancelable) event.preventDefault();
          dx = mx;
          samples.push([event.touches[0].clientX, now()]);
          if (samples.length > 8) samples.shift();
          if (dx === 0) return;
          var d = dx < 0 ? 1 : -1;
          var n = slides.length;
          var k = (index + d + n) % n;
          if (incoming !== k || dir !== d) begin(k, d);
          t = Math.min(1, Math.abs(dx) / ((track.clientWidth || 1) * 0.9));
          requestPaint();
        },
        { passive: false }
      );

      var release = function () {
        if (!touching) return;
        touching = false;
        if (paintRaf !== null) {
          window.cancelAnimationFrame(paintRaf);
          paintRaf = null;
        }
        if (axis === 'x' && incoming !== null) {
          /* Velocidad del dedo en unidades de `t` por ms, positiva
             si iba abriendo el wipe. 0.0008 es un dedo rapido. */
          var span = (track.clientWidth || 1) * 0.9;
          var v = fingerSpeed();
          var open = (dir > 0 ? -v : v) / span;
          var complete = open > 0.0008 || (t > 0.2 && open > -0.0008);
          var remaining = complete ? 1 - t : t;
          /* Con easeOut la velocidad inicial es 3 * remaining / ms:
             se elige ms para que sea la del dedo. Tope: 1.5 veces el
             ritmo normal, para que un dedo lento no deje el wipe
             arrastrandose. Si el dedo estaba quieto, ritmo normal. */
          var ms = wipeMs * remaining;
          var speed = complete ? open : -open;
          if (speed > 0) ms = Math.min((3 * remaining) / speed, ms * 1.5);
          ms = Math.max(120, ms);
          if (complete) {
            paintDots(incoming);
            animate(1, ms, commit, easeOut);
          } else {
            animate(
              0,
              ms,
              function () {
                clearIncoming();
                schedule();
              },
              easeOut
            );
          }
        } else {
          schedule();
        }
        axis = null;
        dx = 0;
      };
      track.addEventListener('touchend', release, { passive: true });
      track.addEventListener('touchcancel', release, { passive: true });

      /* ----- Trackpad (v5.2) -----
         Un deslizamiento horizontal con dos dedos cambia UN banner.
         La inercia del trackpad sigue mandando eventos un rato:
         hasta 200ms de silencio no se acepta otro cambio. */
      var wheelSum = 0;
      var wheelLocked = false;
      var wheelTimer = null;
      root.addEventListener(
        'wheel',
        function (event) {
          if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
          event.preventDefault();
          window.clearTimeout(wheelTimer);
          wheelTimer = window.setTimeout(function () {
            wheelLocked = false;
            wheelSum = 0;
          }, 200);
          if (wheelLocked) return;
          wheelSum += event.deltaX;
          if (Math.abs(wheelSum) > 40) {
            var step = wheelSum > 0 ? 1 : -1;
            wheelLocked = true;
            wheelSum = 0;
            go(index + step, true, step);
          }
        },
        { passive: false }
      );
    }

    /* ----- Cambio automatico: pausas ----- */
    if (autoplay) {
      root.addEventListener('mouseenter', function () {
        hovering = true;
        schedule();
      });
      root.addEventListener('mouseleave', function () {
        hovering = false;
        schedule();
      });

      /* El dedo sobre el banner congela la cuenta (touchstart,
         arriba). Un swipe que cambia de banner la reinicia por
         setIndex; uno que regresa al mismo banner la retoma al
         soltar. */

      document.addEventListener('visibilitychange', schedule);
    }

    onChange(DESKTOP, function () {
      controllers.forEach(function (controller) {
        controller.sync();
      });
      schedule();
    });

    root.jgntHbGo = go;
    setIndex(0);
    /* v6: desde aqui las clases mandan sobre que banner se ve
       (ver el CSS: antes de esto solo se ve el primero). */
    if (multi) root.setAttribute('data-hb-ready', '');

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          var visible = entries[entries.length - 1].isIntersecting;
          controllers.forEach(function (controller) {
            controller.setVisible(visible);
          });
        },
        { rootMargin: '200px 0px' }
      ).observe(root);
    }

    /* v5.1: las fotos de los demas banners dejan de ser lazy en
       cuanto termina de cargar la pagina, para que ya esten listas
       cuando entran con el wipe. */
    if (multi) {
      var eager = function () {
        track.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
          img.loading = 'eager';
        });
      };
      if (document.readyState === 'complete') eager();
      else window.addEventListener('load', eager);
    }
  }

  function boot() {
    var roots = document.querySelectorAll('[data-jgnt-hb]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!(event.target instanceof Element)) return;
    init(event.target.querySelector('[data-jgnt-hb]'));
  });

  /* En el editor: seleccionar un Banner en la barra lateral lleva
     el carrusel a ese banner. */
  document.addEventListener('shopify:block:select', function (event) {
    if (!(event.target instanceof Element)) return;
    var slide = event.target.closest('[data-hb-slide]');
    if (!slide) return;

    var root = slide.closest('[data-jgnt-hb]');
    if (!root || typeof root.jgntHbGo !== 'function') return;

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hb-slide]'));
    root.jgntHbGo(slides.indexOf(slide), false);
  });
})();
